import axios, { AxiosResponse } from 'axios';
import { v4 as uuidv4 } from 'uuid';

import router from '@/router';

import _ from 'lodash';

/** API_URL env var */
declare const API_URL: string;

const ERROR_500 = '/error/500';

/** The axios instance */
const instance = axios.create({
	withCredentials: false,
	baseURL: API_URL ? API_URL : '',
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
});

// Request interceptor to add correlationID globally
instance.interceptors.request.use((config) => {
	config.headers.correlationID = uuidv4();
	return config;
});

// Response interceptor to handle errors globally
instance.interceptors.response.use(
	(response) => {
		if (!_.isNil(_.get(response, 'headers["action-forbidden"]'))) {
			const data = _.get(response, 'data', '');
			if (typeof data === 'string') {
				let complement = data.substring(_.indexOf(data, ':') + 2);
				complement = complement.substring(0, _.indexOf(complement, '<'));
			}
			router.push(ERROR_500);
			return Promise.reject(response);
		}
		return Promise.resolve(response);
	},
	(error) => {
		if (typeof error.response === 'undefined') {
			router.push(ERROR_500);
			return Promise.reject(error);
		}

		const status = error.response.status;

		if (status === 401) {
			if (_.get(error, 'response.data.value.error') === 'expire') {
				router.push('/error/401/expire');
			} else {
				router.push({ name: 'erreur401', params: { error: _.get(error, 'response.data.value.error', '') } });
			}
		} else if (status === 403) {
			router.push('/error/403');
		} else if (status === 404) {
			router.push('/error/404');
		} else if (status === 503) {
			const errorData = _.get(error, 'response.data.value');
			if (errorData && errorData.codeError === 'maintenance') {
				router.push({ name: 'maintenance', params: { error: errorData.libelleError } });
			} else {
				router.push('/error/503');
			}
		} else {
			router.push(ERROR_500);
		}

		return Promise.reject(error);
	}
);

export { instance as axios };
export { AxiosResponse };
